import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createReaction } from '../actions/Reactions';
import { ReactionButton } from '@vimily/bonjoro-ui-components';
import { ReduxState } from '~/types/redux/share';
import { OnReactClickArgs } from '@vimily/bonjoro-ui-components/dist/components/ReactionButton';
import { addEmojiToInput } from '~/utils/emoji-renderer';
import { commentTextChanged } from '../actions';

export function ReactionButtonContainer() {
  const dispatch = useDispatch();

  const { lang, count } = useSelector((state: ReduxState) => ({
    lang: state.root.lang,
    count: state.root.reactionCount,
  }));

  const onClick = (args: OnReactClickArgs) => {
    const replyInput = document.querySelector(
      '#reply-panel-input'
    ) as HTMLTextAreaElement;

    dispatch(createReaction());
    if (replyInput) {
      const updatedValue = addEmojiToInput({
        input: replyInput,
        emoji: args.emoji,
      });

      dispatch(commentTextChanged(updatedValue));
    }
  };

  return (
    <div className='transform absolute right-12 bottom-5 z-50'>
      <ReactionButton
        tooltipText={lang?.thanks}
        initialCount={count}
        hideCount={count === 0}
        hideTooltip={count != undefined && count > 0}
        onClick={onClick}
        className='justify-center items-center flex'
        countClassName='pl-4 text-xl font-medium'
        emojiClassName='text-2xl'
        buttonClassName='!h-[45px]'
        showAnimationClassName='!h-40 !w-40'
        tooltipContainerClassName='!my-0 pr-2.5 !h-10'
        tooltipClassName='h-10 text-xl flex items-center justify-center !h-10'
        tooltipTriangleClassName='!border-l-yellow-700 top-auto'
      />
    </div>
  );
}

export default ReactionButton;
